import { useMutation, useQueryClient } from '@tanstack/react-query';
import { enqueueSnackbar } from 'notistack';

import { ProgrammeRecommendation } from '../types';
import { RecommendationCopyKeys, createRecommendationCopy } from '../copy';

import { createProgrammeRecommendation } from '@api';
import { CurriculumQueryKeys } from '@services';

export const useCreateProgrammeRecommendation = (
    onSuccessCallback?: () => void,
) => {
    const queryClient = useQueryClient();

    const { mutate: createRecommendation, isPending: isCreating } = useMutation(
        {
            mutationFn: (data: Partial<ProgrammeRecommendation>) =>
                createProgrammeRecommendation(data),
            onSuccess: () => {
                enqueueSnackbar(
                    createRecommendationCopy(
                        RecommendationCopyKeys.CREATE_SUCCESS,
                    ),
                    {
                        key: 'create-recommendation-success',
                        testId: 'create-recommendation-success',
                        variant: 'curriculumSnackbar',
                        severity: 'success',
                    },
                );

                queryClient.invalidateQueries({
                    queryKey: [CurriculumQueryKeys.PROGRAMME_RECOMMENDATIONS],
                });

                onSuccessCallback?.();
            },
            onError: (error: Error) => {
                enqueueSnackbar(error.message, {
                    title: createRecommendationCopy(
                        RecommendationCopyKeys.CREATE_ERROR,
                    ),
                    key: 'create-recommendation-error',
                    testId: 'create-recommendation-error',
                    variant: 'curriculumSnackbar',
                    severity: 'error',
                });
            },
        },
    );

    return { createRecommendation, isCreating };
};
